import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieve(parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/orders`, parameters)
    },

    create(parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/orders/create`, parameters)
    },

    update(parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/orders`, parameters)
    },

    get(orderId) {
        return requester.get(`${BACKEND_API_V1_URL}/orders/${orderId}`)
    },

    getDocument(docId) {
        return requester.get(`${BACKEND_API_V1_URL}/orders/document/${docId}`)
    },

    saveDocument(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/orders/document`,
            parameters
        )
    },

    addDocuments(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/orders/add-documents`,
            parameters
        )
    },

    getItems(parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/orders/items`, parameters)
    },
}
